import { Paper, Stack, Typography } from '@mui/material';
import { CustomerConfiguration } from '../../CreateCustomerPage/create-customer-page-components/CreateCustomerConfiguration/create-customer-configuration-components/CustomerConfiguration';
import { CustomerInvoicesConfiguration } from '../../CreateCustomerPage/create-customer-page-components/CreateCustomerConfiguration/create-customer-configuration-components/CustomerInvoicesConfiguration';
import { CustomerPaymentConfiguration } from '../../CreateCustomerPage/create-customer-page-components/CreateCustomerConfiguration/create-customer-configuration-components/CustomerPaymentConfiguration';
import { Customer, UpdateCustomer } from '@vy/types';
import { fromNullToUndefined, isEmptyArray } from '@vy/utils';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

type UpdateCustomerConfigurationProps = {
  customer: Customer;
};

export const UpdateCustomerConfiguration: React.FC<UpdateCustomerConfigurationProps> = ({ customer }) => {
  const mode = 'update';

  const { watch } = useFormContext<UpdateCustomer>();

  const customCrmId = watch('crmMetadata')?.crmId;

  const connectedCrmIntegrationEntity = useMemo(() => {
    return customer.integrationEntities?.find((entity) => entity.integrationExternalId === customCrmId);
  }, [customer, customCrmId]);

  const integrationProvider = connectedCrmIntegrationEntity?.integrationProvider ?? null;

  const crmCustomFieldsOptions = useMemo(() => {
    if (isEmptyArray(customer.customFieldValues)) {
      return [];
    }

    return customer.customFieldValues.map(({ fieldName, value }) => ({
      label: fieldName ?? '',
      value: value ?? '',
    }));
  }, [customer.customFieldValues]);

  return (
    <Paper
      elevation={1}
      sx={{
        padding: '24px 32px',
        borderRadius: '10px',
        boxShadow: '0px 10px 24px rgba(0,0,0,0.03)',
        border: '1px solid rgba(13,27,39,0.1)',
        minHeight: '440px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minWidth: '880px',
      }}
    >
      <Stack spacing={3}>
        <Typography variant="h5" sx={{ fontWeight: 500, paddingTop: 1 }}>
          Configuration
        </Typography>

        <CustomerConfiguration
          mode={mode}
          crmCustomFieldsOptions={crmCustomFieldsOptions}
          integrationProvider={fromNullToUndefined(integrationProvider)}
        />
        <CustomerInvoicesConfiguration mode={mode} customerId={customer.id} />
        <CustomerPaymentConfiguration mode={mode} />
      </Stack>
    </Paper>
  );
};
